import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { View } from '../../../Base';

const useStyles = makeStyles(() => ({
  list: {
    overflowY: 'overlay',
    maxHeight: '100%',
    height: '100%',
  },
  '@supports ( -moz-appearance:none )': {
    list: {
      overflowY: 'auto',
      scrollbarWidth: 'thin',
    },
  },
}));

const ListWrapper = ({ children }) => {
  const styles = useStyles();
  return (
    <View className={styles.list} data-testid="route-list">
      {children}
    </View>
  );
};

export default memo(ListWrapper);
